module.exports = __webpack_public_path__ + "static/media/jackpot-displayed-screen.64f12ca8.png";